// QR Menü adisyon yazdırma (fiş) ayarları penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.qrReceiptSettings';

export const qrReceiptSettingsGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Adisyon Yazdırma Ayarları nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'QR menü siparişlerinden yazdırılan adisyonun (fişin) başlığını, alt yazısını ve kağıt ölçülerini belirlersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Fiş ayarları'),
    footer: t(`${G}.regions.footer`, 'Kaydet'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Fiş başlığını seçin'),
      text: t(`${G}.s1.text`, '"Metin Başlık (Şirket Bilgileri)" seçerseniz fişin üstüne Şirket Adı, Vergi Numarası ve Şirket Adresi yazılır. "Logo Başlık" seçerseniz "Logo Yükle" ile logonuzu ekleyin.'),
      tips: [
        t(`${G}.s1.tip1`, 'Logo en fazla 5MB ve resim dosyası (JPG/PNG) olmalı. "Logoyu Kaldır" logoyu siler.'),
        t(`${G}.s1.tip2`, '"Fiş başlık metni/logosu göster" kapalıysa başlık basılmaz; Logo Başlık seçiliyken bu kutu otomatik açıktır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Yazdırma ayarları'),
      text: t(`${G}.s2.text`, '"Ara Toplam ve KDV Toplam göster" ile fişe ara toplam ve KDV satırlarını ekleyin. Aynı fişten kaç adet çıkacağını 1 ile 9 arasında girin.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Alt bilgi'),
      text: t(`${G}.s3.text`, 'Fişin altına basılacak standart notu (ör. iade koşulları) ve teşekkür mesajını / sloganınızı yazın.'),
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Fiş formatı'),
      text: t(`${G}.s4.text`, 'Fiş Genişliği (mm), satır başına Karakter Uzunluğu ve üst / alt / sol / sağ kenar boşluklarını (mm) yazıcınızın kağıdına göre girin. Yazı taşıyor veya kesiliyorsa bu değerleri küçültün.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Kaydedin'),
      text: t(`${G}.s5.text`, '"Kaydet" pencereyi kapatır ve ayarları QR Menü Ayarları\'na aktarır. Kalıcı olması için ardından QR Menü Ayarları penceresini de kaydedin.'),
      tips: [
        t(`${G}.s5.tip1`, 'Şirket Adı boşsa Kaydet çalışmaz; Logo Başlık seçiliyken bile önce Metin Başlık\'a geçip Şirket Adı\'nı doldurun.'),
      ],
    },
  ],
});
